import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addcuisine',
  templateUrl: './addcuisine.component.html',
  styleUrls: ['./addcuisine.component.css']
})
export class AddcuisineComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  saveloading: boolean;
  successfully: boolean;


  //Edit Get Values
  cuisineColl: any = [];
  cuisineid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  cuisineform = new FormGroup({
    cuisineid: new FormControl(0),
    cuisinename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Cuisine";


  @Input() cuisinename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.cuisineid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.cuisineform.reset();
      this.fnInitializeCuisine();

      if (this.cuisineid > 0) {
        this.fngetCuisine();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.cuisineid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCuisine() {
    this.cuisineform.setValue({

      cuisineid: 0,
      cuisinename: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetCuisine() {
   
    var data = {
      'cuisineid': this.cuisineid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCuisine(data)
      .subscribe(
        (res) => {
          this.cuisineColl = res.json().result;
          var editdata = this.cuisineColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.cuisineform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'cuisineid': this.cuisineid,
          'cuisinename': this.cuisineform.get('cuisinename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.cuisineform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckCuisine(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.cuisineform.get('cuisineid').value > 0) {
                //Update Department
                this.fnSetCuisine(data);
              }
              else {
                //Insert Department
                this.fnInsertCuisine(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.cuisineform.controls['cuisinename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertCuisine(data) {

    this.appService.fnInsertCuisine(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The new Cuisine has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.cuisineid);

          this.emitData.emit(this.cuisineid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetCuisine(data) {

    this.appService.fnSetCuisine(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The cuisine has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.cuisineid, data.cuisinename);

          this.emitData.emit(this.cuisineid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.cuisineform.setValue({

      cuisineid: deptBO.cuisineid,
      cuisinename: deptBO.cuisinename,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
